var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"onboarding-copy-code",attrs:{"align-center":"","justify-center":""}},[_c('page-title',{attrs:{"title":"Publish"}}),_c('CopyCode',{attrs:{"campaign":_vm.$store.getters['user/currentCampaign']}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }